import {
  CENTS_PER_DOLLAR,
  CLAIM_AMOUNT_MAX_DIGITS,
} from '@/shared/constants/claims'
import { formatCurrency } from '@/shared/helpers/format-currency'

// Cash-register style amount input: only digits are kept and they fill the
// cents from the right, so typing 15050 shows $150.50

export function toAmountCents(value: string): string {
  return value
    .replace(/\D/g, '')
    .replace(/^0+/, '')
    .slice(0, CLAIM_AMOUNT_MAX_DIGITS)
}

export function formatAmountCents(cents: string): string {
  return cents ? formatCurrency(Number(cents) / CENTS_PER_DOLLAR) : ''
}
